import { readEmployeesSchedules } from "@/pages/human-resources/time-management/endpoints/schedules/SchedulesEndpoints.ts";
import { mapToSchedules } from "@/pages/human-resources/time-management/endpoints/schedules/inout/ScheduleOut.ts";
import type { Schedule } from "@/pages/human-resources/time-management/business/schedule/Schedule.ts";
import type { EmployeesContractsManager } from "@/pages/human-resources/time-management/business/EmployeesContractsManager.ts";
import type { ScheduleReferenceData } from "@/pages/human-resources/time-management/business/reference/ScheduleReferenceData.ts";

export async function fetchSchedules(
  refData: ScheduleReferenceData,
  contractsManager: EmployeesContractsManager,
): Promise<Schedule[]> {
  const { siteId, startDate: start, endDate: end } = contractsManager;

  const relatedSitesIds = Array.from(
    contractsManager.getRelatedSitesIds().values(),
  ).map((s) => parseInt(s));

  const employeesIds = Array.from(
    contractsManager.getEmployeesIds().values(),
  ).map((s) => parseInt(s));

  const schedulesOut = await readEmployeesSchedules(
    siteId,
    relatedSitesIds,
    employeesIds,
    start,
    end,
  );
  return mapToSchedules(refData, schedulesOut);
}
